import BaseSource from "./base_source"
import { debounceAsync } from "../../helpers/timing_helper"

const DEBOUNCE_INTERVAL = 200
const MAX_RENDERED_SUGGESTIONS = 100

export default class RemoteFilterSource extends BaseSource {
  constructor(url, filterParam) {
    super()

    this.baseURL = url
    this.filterParam = filterParam
    this.loadAndFilterListItems = debounceAsync(this.fetchFilteredListItems.bind(this), DEBOUNCE_INTERVAL)
  }

  async buildListItems(filter = "") {
    return await this.loadAndFilterListItems(filter)
  }

  promptItemFor(listItem) {
    return this.promptItemByListItem.get(listItem)
  }

  async fetchFilteredListItems(filter) {
    const promptItems = await this.loadPromptItemsFromUrl(this.#urlFor(filter))
    return this.#buildListItemsFromPromptItems(promptItems)
  }

  #urlFor(filter) {
    const url = new URL(this.baseURL, window.location.origin)
    url.searchParams.append(this.filterParam, filter)
    return url.toString()
  }

  #buildListItemsFromPromptItems(promptItems) {
    const listItems = []
    this.candidatePromptItems = promptItems
    this.promptItemByListItem = new WeakMap()

    for (const promptItem of promptItems) {
      if (listItems.length >= MAX_RENDERED_SUGGESTIONS) break

      const listItem = this.buildListItemElementFor(promptItem)
      this.promptItemByListItem.set(listItem, promptItem)
      listItems.push(listItem)
    }

    return listItems
  }
}
